import React, { useEffect, useState } from 'react'
import { faEye, faPencil, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import 'datatables.net-responsive-dt';

function Feedback() {
  DataTable.use(DT);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData([
      { id: 1, username: 'Tom Latham', comments: 'Lorem epsum'},
      { id: 2, username: 'Chris Joans', comments: 'Lorem epsum' },
      { id: 3, username: 'Kapil Sharma', comments: 'Lorem epsum'},
      { id: 4, username: 'Siddhart Malhotra', comments: 'Lorem epsum'},
    ]);

  }, [])


  const handleAdd = (e) => {
    e.preventDefault();
    navigate('/add-feedback');
  }

  const handleEdit = (e, id) => {
    e.preventDefault();
    //console.log(id);
    navigate('/add-feedback/' + id);
  }

  // const handleDelete = (e, id) => {
  //   e.preventDefault();
  //   //console.log(id);
  //   alert('Implement delete logic');
  // }

  // const handleStatus = (e, data, row) => {
  //   alert('handle status update for id: ' + row.id);
  // }

  return (
    <Row>
      <Col md={12}>
        <Card className='mb-4'>
          <CardHeader className='pb-0'>
            <Row>
              <Col md={9}>
                <h4>Feedback List</h4>
              </Col>
              <Col md={3} className='d-grid d-md-flex justify-content-md-end d-sm-block'>
                <Button variant='outline-primary' className='btn-sm' onClick={handleAdd}>Add feedback</Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className='px-0 pt-0 pb-2'>

            <div className='mx-3'>
              <DataTable className="display table align-items-center mb-0 p-0"
                data={tableData}
                options={{
                  responsive: true,
                  columns: [
                    { data: 'username', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'comments', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'id', className: 'text-secondary text-sm font-weight-bold align-middle text-center' },
                  ],
                }}
                slots={{                  
                  2: (data, row) => {
                    return (
                      <React.Fragment>
                        <a className='me-3 cursor-pointer' title='View' onClick={(e) => handleEdit(e, data)} >
                          <FontAwesomeIcon icon={faEye} size='lg'></FontAwesomeIcon>
                        </a>                        
                      </React.Fragment>
                    );
                  },
                }}
              >
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">User name</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Comments</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Action</th>
                  </tr>
                </thead>
              </DataTable>
            </div>

          </CardBody>

        </Card>
      </Col>
    </Row>
  )
}

export default Feedback